/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Show_LessInputs */

const en_messages_show_less = /** @type {(inputs: Messages_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show less`)
};

const he_messages_show_less = /** @type {(inputs: Messages_Show_LessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצג פחות`)
};

/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Messages_Show_LessInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_show_less = /** @type {((inputs?: Messages_Show_LessInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Show_LessInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_show_less(inputs)
	return he_messages_show_less(inputs)
});